import Navbar from '@/components/feature/Navbar';
import HeroSection from './components/HeroSection';
import TrustSection from './components/TrustSection';
import TasksSection from './components/TasksSection';
import EquipmentSection from './components/EquipmentSection';
import SolutionsSection from './components/SolutionsSection';
import IndustriesSection from './components/IndustriesSection';
import WhyUsSection from './components/WhyUsSection';
import HowWeWorkSection from './components/HowWeWorkSection';
import ContactForm from './components/ContactForm';
import FinalCTA from './components/FinalCTA';
import Footer from './components/Footer';

export default function Home() {
  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      <main>
        <HeroSection />
        <TrustSection />
        <TasksSection />
        <EquipmentSection />
        <SolutionsSection />
        <IndustriesSection />
        <WhyUsSection />
        <HowWeWorkSection />
        <ContactForm />
        <FinalCTA />
      </main>
      <Footer />
    </div>
  );
}